import React, { useState } from "react";
import { HierarchyProvider, useHierarchy } from "./contexts/HierarchyContext.jsx";
import Sidebar from "./components/Sidebar.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import TestCaseEditor from "./pages/TestCaseEditor.jsx";
import ManualCall from "./pages/ManualCall.jsx";
import RunHistory from "./pages/RunHistory.jsx";
import RunDetail from "./pages/RunDetail.jsx";
import PatientList from "./pages/PatientList.jsx";
import PhysicianList from "./pages/PhysicianList.jsx";
import PhysicianEditor from "./pages/PhysicianEditor.jsx";
import PhysicianMatch from "./pages/PhysicianMatch.jsx";
import ManualText from "./pages/ManualText.jsx";
import Library from "./pages/Library.jsx";
import GitHubSettings from "./pages/GitHubSettings.jsx";
import Settings from "./pages/Settings.jsx";

function AppShell() {
  const [page, setPage] = useState("dashboard");
  const [pageProps, setPageProps] = useState({});
  const { subTenantId } = useHierarchy();

  const navigate = (p, props = {}) => {
    setPage(p);
    setPageProps(props);
  };

  const renderPage = () => {
    if (!subTenantId) {
      return (
        <div style={{ padding: 60, textAlign: "center", color: "#999" }}>
          <div style={{ fontSize: 28, marginBottom: 12 }}>Select a sub-tenant</div>
          <div style={{ fontSize: 14 }}>Choose an organization, tenant, and sub-tenant from the sidebar to begin testing.</div>
        </div>
      );
    }
    switch (page) {
      case "dashboard": return <Dashboard navigate={navigate} />;
      case "editor": return <TestCaseEditor navigate={navigate} testCaseId={pageProps.testCaseId} />;
      case "history": return <RunHistory navigate={navigate} />;
      case "run-detail": return <RunDetail navigate={navigate} runId={pageProps.runId} />;
      case "patients": return <PatientList navigate={navigate} />;
      case "physicians": return <PhysicianList navigate={navigate} />;
      case "physician-editor": return <PhysicianEditor navigate={navigate} physicianId={pageProps.physicianId} />;
      case "physician-match": return <PhysicianMatch navigate={navigate} />;
      case "library": return <Library navigate={navigate} />;
      case "github": return <GitHubSettings navigate={navigate} />;
      case "settings": return <Settings navigate={navigate} />;
      case "manual-text": return <ManualText navigate={navigate} />;
      case "manual-call": return null; // mounted separately below
      default: return <Dashboard navigate={navigate} />;
    }
  };

  return (
    <div style={styles.app}>
      <style>{globalCSS}</style>
      <Sidebar page={page} onNavigate={navigate} />
      <main style={styles.main} key={subTenantId || "none"}>
        {/* ManualCall stays mounted to keep WebSocket alive */}
        <div style={{ display: page === "manual-call" ? "flex" : "none", flexDirection: "column", height: "100%" }}>
          {subTenantId && <ManualCall navigate={navigate} />}
        </div>
        {page !== "manual-call" && renderPage()}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <HierarchyProvider>
      <AppShell />
    </HierarchyProvider>
  );
}

const globalCSS = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    background: #fff; color: #0f0f0f;
    -webkit-font-smoothing: antialiased;
  }
  button { cursor: pointer; font-family: inherit; }
  input, textarea, select { font-family: inherit; }
  ::selection { background: #d4e4ff; }
  @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }
  @keyframes spin { to { transform: rotate(360deg); } }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }
`;

const styles = {
  app: { display: "flex", minHeight: "100vh" },
  main: { flex: 1, overflow: "auto", background: "#fff" },
};
